export default function WebhookList( { webhooks, loading, onEdit, onDelete, onNew } ) {
	if ( loading ) {
		return (
			<div className="rtwc-loading">
				<span className="spinner is-active" />
				<span>Loading webhooks…</span>
			</div>
		);
	}

	if ( ! webhooks.length ) {
		return (
			<div className="rtwc-empty-state">
				<span className="dashicons dashicons-rest-api rtwc-empty-icon" />
				<h2>No webhooks yet</h2>
				<p>Create your first webhook to start sending CF7 form data to external services.</p>
				<button className="button button-primary button-hero" onClick={ onNew }>
					+ Add New Webhook
				</button>
			</div>
		);
	}

	return (
		<div className="rtwc-list">
			<table className="wp-list-table widefat fixed striped">
				<thead>
					<tr>
						<th>Name</th>
						<th>Webhook URL</th>
						<th>Method</th>
						<th>CF7 Form</th>
						<th>Status</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{ webhooks.map( ( wh ) => (
						<tr key={ wh.id }>
							<td>
								<strong>
									<button className="button-link" onClick={ () => onEdit( wh.id ) }>
										{ wh.title || `Webhook #${ wh.id }` }
									</button>
								</strong>
							</td>
							<td>
								<code className="rtwc-url-cell" title={ wh.url }>
									{ wh.url ? truncate( wh.url, 45 ) : <em style={ { color: '#aaa' } }>Not set</em> }
								</code>
							</td>
							<td>
								<span className={ `rtwc-badge rtwc-badge--${ ( wh.method || 'POST' ).toLowerCase() }` }>
									{ wh.method || 'POST' }
								</span>
							</td>
							<td>{ wh.cf7_form_title || `Form #${ wh.cf7_form_id || '—' }` }</td>
							<td>
								<span className={ `rtwc-status rtwc-status--${ wh.status }` }>
									{ wh.status === 'publish' ? '● Active' : '○ Draft' }
								</span>
							</td>
							<td className="rtwc-actions">
								<button className="button button-small" onClick={ () => onEdit( wh.id ) }>
									Edit
								</button>
								{ ' ' }
								<button
									className="button button-small rtwc-delete-btn"
									onClick={ () => onDelete( wh.id ) }
								>
									Delete
								</button>
							</td>
						</tr>
					) ) }
				</tbody>
			</table>
		</div>
	);
}

function truncate( str, max ) {
	return str.length > max ? str.slice( 0, max ) + '…' : str;
}
